var _jsxFileName = "/codebuild/output/src1718503544/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/steps/RegisterMinorAccount.tsx";
import React from 'react';
import { Text } from '@adc/parallax-component-library';
import { FormContainer, Input, InputPassword, PasswordInputValidator, PhoneInput } from 'Components/utility';
import i18n from 'Utilities/i18n';
import { ContentContainer } from '../helpers';
function RegisterMinorAccount({
  formController,
  passwordRules,
  onValidate,
  showPhoneInput
}) {
  const {
    errors,
    values,
    touched,
    handleChange,
    handleBlur
  } = formController;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 7
    }
  }, i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.primaryText')), /*#__PURE__*/React.createElement(FormContainer, {
    hasHiddenUserInput: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.formField.parentEmail.label'),
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.formField.parentEmail.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.formField.parentEmail.label'),
    errorMessage: errors.email,
    isInvalid: errors.email && touched.email ? true : false,
    testID: "email",
    value: values.email,
    onChangeText: handleChange('email'),
    onBlur: handleBlur('email'),
    inputMode: "email",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 9
    }
  }), showPhoneInput && /*#__PURE__*/React.createElement(PhoneInput, {
    "aria-label": i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    errorMessage: errors.mobileNumber,
    isInvalid: errors.mobileNumber && touched.mobileNumber ? true : false,
    testID: "mobileNumber",
    value: values.mobileNumber,
    onChangeText: handleChange('mobileNumber'),
    onBlur: handleBlur('mobileNumber'),
    maxLength: 15,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(PasswordInputValidator, {
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.label'),
    errors: errors,
    touched: touched,
    handleBlur: handleBlur('password'),
    onChangeText: handleChange('password'),
    password: values.password,
    onValidate: onValidate,
    passwordRules: passwordRules,
    testID: "password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(InputPassword, {
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.label'),
    isInvalid: errors.confirmPassword && touched.confirmPassword ? true : false,
    errorMessage: errors.confirmPassword,
    testID: "confirmPassword",
    onBlur: handleBlur('confirmPassword'),
    onChangeText: handleChange('confirmPassword'),
    defaultValue: values.confirmPassword,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 9
    }
  })));
}
export { RegisterMinorAccount };